import { Card, Skeleton, withStyles } from 'vopay';
import { Title } from 'UI';
import { useTranslation } from 'react-i18next';
import styles from './RolesSummaryCard.module.scss';

const cn = withStyles(styles);

export type RoleCount = {
  id: string;
  name: string;
  count: number;
};

type RolesSummaryCardProps = {
  roles: RoleCount[];
  fetching?: boolean;
};

// Presentational only — where `roles` comes from is the caller's concern.
// TODO: partner portal has no roles endpoint yet, so counts are tallied
// client-side from the already-fetched user list (see
// useComputePartnerRoleCounts). Once a real endpoint exists, swap that hook
// out; this component's props/markup shouldn't need to change.
export default function RolesSummaryCard({ roles, fetching }: RolesSummaryCardProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Users.List.Roles' });

  if (fetching) {
    return (
      <Card hoverEffect={false} className={cn('container')}>
        <Skeleton height="80px" />
      </Card>
    );
  }

  return (
    <Card hoverEffect={false} className={cn('container')}>
      <Title level="4" className={cn('headerTitle')}>
        {t('title', { defaultValue: 'Roles' })}
      </Title>

      <div className={cn('roleCards')}>
        {roles.map((role) => (
          <div key={role.id} className={cn('roleCard')}>
            <span className={cn('roleCardName')}>{role.name}</span>
            <span className={cn('roleCardCount')}>{role.count}</span>
          </div>
        ))}
      </div>
    </Card>
  );
}
